import { render, staticRenderFns } from "./AppShopifyProductVariantSelectorTile.vue?vue&type=template&id=49e418b2&"
import script from "./AppShopifyProductVariantSelectorTile.vue?vue&type=script&lang=js&"
export * from "./AppShopifyProductVariantSelectorTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BundleProductTile: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/BundleProductTile.vue').default})
